export default (text = '') => (params: { [param: string]: string } = {}) =>
  Object.entries(params).reduce(
    (acc, [key, value]) => acc.replace(new RegExp(`{${key}}`, 'g'), value),
    text
  );
